import { BLOG_CATEGORIES } from './blog';

// Временная карта на период параллельной работы legacy и redesign. После миграции удалить.
export const getLegacyDesignTarget = (href: string): string => {
  const url = new URL(href);
  const path = url.pathname.replace(/\/+$/, '') || '/';

  if (path === '/auth') {
    const redirect = url.searchParams.get('redirectUrl');
    if (redirect?.startsWith('/')) {
      try {
        const target = new URL(redirect, url.origin);
        if (target.origin === url.origin && !/^\/auth(?:\/|$)/.test(target.pathname)) {
          return getLegacyDesignTarget(target.href);
        }
      } catch {
        // Повреждённый redirectUrl не должен мешать переходу в личный кабинет.
      }
    }
    return '/profile';
  }

  if (path === '/2plus1') {
    url.pathname = '/catalog';
    url.searchParams.set('two-plus-one', '1');
  } else if (path === '/balance' || /^\/tags(?:\/|$)/.test(path)) {
    url.pathname = '/catalog';
  } else if (/^\/catalog(?:\/|$)/.test(path)) {
    const segments = path.split('/');
    const tagIndex = segments.indexOf('tags', 2);
    if (tagIndex !== -1) url.pathname = segments.slice(0, tagIndex).join('/');
  } else if (path === '/blog' && url.searchParams.has('categories')) {
    const category = url.searchParams.get('categories')?.split(',')[0];
    if (category && category !== 'all') {
      url.pathname = BLOG_CATEGORIES.some(({ code }) => code === category)
        ? `/blog/${category}`
        : `/article/${encodeURIComponent(category)}`;
    }
    url.searchParams.delete('categories');
  }

  return url.pathname + url.search + url.hash;
};
